import Vue from 'vue'
import Router from 'vue-router'
import ErrorPage from '@/components/ErrorPage'
import Quax from '@/components/Quax/Index'
import QuaxScan from '@/components/Quax/Scan'
import QuaxActivity from '@/components/Quax/Activity'
import QiHan from '@/components/QiHan/Loading'
import QiHanIndex from '@/components/QiHan/Index'
import AiNiu from '@/components/AiNiu/Index'
import AiNiuScan from '@/components/AiNiu/Scan'
import FeiMi from '@/components/Feimi/Index'
import ZMNAnti from '@/components/ZhuoMuNiao/Anti'
import ZMNQuery from '@/components/ZhuoMuNiao/Query'
import LBTScan from '@/components/LiuBaoTang/Index'
import LBTQuery from '@/components/LiuBaoTang/Query'
import JZScan from '@/components/JiuZan/Index'
import JZQuery from '@/components/JiuZan/Query'
import MonTon from '@/components/MaiTeng/Index'
import MonTonStore from '@/components/MaiTeng/Store'
import SSScan from '@/components/ShengSheng/Index'
import SSResult from '@/components/ShengSheng/Result'
import SSJoin from '@/components/ShengSheng/Join'
import SSRule from '@/components/ShengSheng/Rule'
import BaXiaScan from '@/components/BaXia/Scan'
import BaXiaIndex from '@/components/BaXia/Index'
import BaXiaTrace from '@/components/BaXia/Trace'
import BaXiaJoin from '@/components/BaXia/Join'
import JST from '@/components/JinShaTan/Scan'
import JSTResult from '@/components/JinShaTan/Result'
import ZhuaQiuQuery from '@/components/ZhuaQiu/Query'
import ZhuaQiuResult from '@/components/ZhuaQiu/Result'
import ZhuaQiuTrace from '@/components/ZhuaQiu/Trace'
import ZhuaQiuJoin from '@/components/ZhuaQiu/Join'
import ZhuaQiuIndex from '@/components/ZhuaQiu/Index'
import MagicStoneScan from '@/components/MagicStone/Scan'
import MagicStoneIndex from '@/components/MagicStone/Index'
import MagicStoneTrace from '@/components/MagicStone/Trace'
import NaitureIndex from '@/components/Naiture/Index'
import NaitureQuery from '@/components/Naiture/Query'
import ILanIndex from '@/components/ILan/Index'
import ILanResult from '@/components/ILan/Result'
import ILanReport from '@/components/ILan/Report'
import JunHeIndex from '@/components/JunHe/Index'
import JunHeRule from '@/components/JunHe/Rule'
import JunHeActivity from '@/components/JunHe/Activity'
import JunHeRecord from '@/components/JunHe/Record'
import Valore from '@/components/Valore/Index'
import ValoreActivity from '@/components/Valore/Activity'
import ValoreRule from '@/components/Valore/Rule'
import CyqScan from '@/components/Cyq/Scan'
import CyqResult from '@/components/Cyq/Result'
import CyqActivity from '@/components/Cyq/Activity'
import JiaTang from '@/components/JiaTang/Index'
import Astaxin from '@/components/Astaxin/Index'
import AstaxinCN from '@/components/Astaxin/CN'
import AstaxinScan from '@/components/Astaxin/Scan'
import AstaxinEntry from '@/components/Astaxin/Entry'
import MuTengResult from '@/components/MuTeng/Result'
import MuTengClaimResult from '@/components/MuTeng/ClaimResult'
import MuTengRule from '@/components/MuTeng/Rule'
import AobangResult from '@/components/Aobang/Result'
import MoGuJiaScan from '@/components/MoGuJia/Scan'
import MoGuJiaResult from '@/components/MoGuJia/Result'
import MoGuJiaFollow from '@/components/MoGuJia/Follow'
import FengTuoYuanScan from '@/components/FengTuoYuan/Scan'
import FengTuoYuanResult from '@/components/FengTuoYuan/Result'
import FengTuoYuanTrace from '@/components/FengTuoYuan/Trace'
import FengTuoYuanActivity from '@/components/FengTuoYuan/Activity'
import AnKangScan from '@/components/AnKang/Scan'
import AnKangIndex from '@/components/AnKang/Index'
import AnKangTrace from '@/components/AnKang/Trace'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/quax',
      name: 'QuaxIndex',
      component: Quax,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/ainiu',
      name: 'AiNiuIndex',
      component: AiNiu,
      meta: {
        title: '积分查询'
      }
    },
    {
      path: '/ssheng',
      name: 'ShengSheng',
      component: SSScan,
      meta: {
        title: '盛生'
      }
    },
    {
      path: '/ssheng/result',
      name: 'ShengShengResult',
      component: SSResult,
      meta: {
        title: '盛生'
      }
    },
    {
      path: '/ssheng/join',
      name: 'ShengShengJoin',
      component: SSJoin,
      meta: {
        title: '盛生'
      }
    },
    {
      path: '/ssheng/rule',
      name: 'ShengShengRule',
      component: SSRule,
      meta: {
        title: '积分规则'
      }
    },
    {
      path: '/feimi',
      name: 'FeiMi',
      component: FeiMi,
      meta: {
        title: 'Feimibox费米盒子'
      }
    },
    {
      path: '/monton',
      name: 'MonTonIndex',
      component: MonTon,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/monton/storePage',
      name: 'MonTonStore',
      component: MonTonStore,
      meta: {
        title: '一店一码首页'
      }
    },
    {
      path: '/zmn.query',
      name: 'ZhuoMuNiaoQuery',
      component: ZMNQuery,
      meta: {
        title: '啄木鸟防伪查询'
      }
    },
    {
      path: '/lbt',
      name: 'LiuBaoTangIndex',
      component: LBTScan,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/lbt.query',
      name: 'LiuBaoTangQuery',
      component: LBTQuery,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/jz',
      name: 'JiuZanIndex',
      component: JZScan,
      meta: {
        title: '世纪沉香坊'
      }
    },
    {
      path: '/jz.query',
      name: 'JiuZanQuery',
      component: JZQuery,
      meta: {
        title: '世纪沉香坊'
      }
    },
    {
      path: '/zmn',
      name: 'ZhuoMuNiao',
      component: ZMNAnti,
      meta: {
        title: '啄木鸟防伪查询'
      }
    },
    {
      path: '/ainiu/scan',
      name: 'AiNiuScan',
      component: AiNiuScan,
      meta: {
        title: '积分查询'
      }
    },
    {
      path: '/quax/scan',
      name: 'QuaxScan',
      component: QuaxScan,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/quax/activity',
      name: 'QuaxActivity',
      component: QuaxActivity,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/qh',
      name: 'QiHan',
      component: QiHan,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/qh/index',
      name: 'QiHanIndex',
      component: QiHanIndex,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/bxia/scan',
      name: 'BaXiaScan',
      component: BaXiaScan,
      meta: {
        title: 'Vansia·王溪'
      }
    },
    {
      path: '/bxia/index',
      name: 'BaXiaIndex',
      component: BaXiaIndex,
      meta: {
        title: 'Vansia·王溪'
      }
    },
    {
      path: '/bxia/trace',
      name: 'BaXiaTrace',
      component: BaXiaTrace,
      meta: {
        title: 'Vansia·王溪'
      }
    },
    {
      path: '/bxia/join',
      name: 'BaXiaJoin',
      component: BaXiaJoin,
      meta: {
        title: 'Vansia·王溪'
      }
    },
    {
      path: '/jst',
      name: 'JinShaTan',
      component: JST,
      meta: {
        title: '青西金啤'
      }
    },
    {
      path: '/jst/result',
      name: 'JinShaTanResult',
      component: JSTResult,
      meta: {
        title: '青西金啤'
      }
    },
    {
      path: '/zhuaqiu/query',
      name: 'ZhuaQiuQuery',
      component: ZhuaQiuQuery,
      meta: {
        title: '抓球'
      }
    },
    {
      path: '/zhuaqiu/result',
      name: 'ZhuaQiuResult',
      component: ZhuaQiuResult,
      meta: {
        title: '抓球'
      }
    },
    {
      path: '/zhuaqiu/trace',
      name: 'ZhuaQiuTrace',
      component: ZhuaQiuTrace,
      meta: {
        title: '抓球'
      }
    },
    {
      path: '/zhuaqiu/join',
      name: 'ZhuaQiuJoin',
      component: ZhuaQiuJoin,
      meta: {
        title: '抓球'
      }
    },
    {
      path: '/zhuaqiu',
      name: 'ZhuaQiuIndex',
      component: ZhuaQiuIndex,
      meta: {
        title: '抓球'
      }
    },
    {
      path: '/magicstone/scan',
      name: 'MagicStoneScan',
      component: MagicStoneScan,
      meta: {
        title: '魔石'
      }
    },
    {
      path: '/magicstone',
      name: 'MagicStoneIndex',
      component: MagicStoneIndex,
      meta: {
        title: '魔石'
      }
    },
    {
      path: '/magicstone/trace',
      name: 'MagicStoneTrace',
      component: MagicStoneTrace,
      meta: {
        title: '魔石'
      }
    },
    {
      path: '/naiture',
      name: 'NaitureIndex',
      component: NaitureIndex,
      meta: {
        title: 'Authenticity & Traceability'
      }
    },
    {
      path: '/naiture/query',
      name: 'NaitureQuery',
      component: NaitureQuery,
      meta: {
        title: 'Naiture'
      }
    },
    {
      path: '/ilan',
      name: 'ILanIndex',
      component: ILanIndex,
      meta: {
        title: '伊兰之谜'
      }
    },
    {
      path: '/ilan/result',
      name: 'ILanResult',
      component: ILanResult,
      meta: {
        title: '伊兰之谜'
      }
    },
    {
      path: '/ilan/report',
      name: 'ILanReport',
      component: ILanReport,
      meta: {
        title: '伊兰之谜'
      }
    },
    {
      path: '/junhe',
      name: 'JunHeIndex',
      component: JunHeIndex,
      meta: {
        title: 'NIDEK'
      }
    },
    {
      path: '/junhe/rule',
      name: 'JunHeRule',
      component: JunHeRule,
      meta: {
        title: 'NIDEK'
      }
    },
    {
      path: '/junhe/activity',
      name: 'JunHeActivity',
      component: JunHeActivity,
      meta: {
        title: 'NIDEK'
      }
    },
    {
      path: '/junhe/record',
      name: 'JunHeRecord',
      component: JunHeRecord,
      meta: {
        title: 'NIDEK'
      }
    },
    {
      path: '/valore/index',
      name: 'ValoreIndex',
      component: Valore,
      meta: {
        title: 'VALORE AOE'
      }
    },
    {
      path: '/valore/activity',
      name: 'ValoreActivity',
      component: ValoreActivity,
      meta: {
        title: 'VALORE AOE'
      }
    },
    {
      path: '/valore/rule',
      name: 'ValoreRule',
      component: ValoreRule,
      meta: {
        title: 'VALORE AOE'
      }
    },
    {
      path: '/cyq/scan',
      name: 'CyqScan',
      component: CyqScan,
      meta: {
        title: '草原情'
      }
    },
    {
      path: '/cyq/result',
      name: 'CyqResult',
      component: CyqResult,
      meta: {
        title: '草原情'
      }
    },
    {
      path: '/cyq/activity',
      name: 'CyqActivity',
      component: CyqActivity,
      meta: {
        title: '草原情'
      }
    },
    {
      path: '/jiatang',
      name: 'JiaTangIndex',
      component: JiaTang,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/astaxin/entry',
      name: 'AstaxinEntry',
      component: AstaxinEntry,
      meta: {
        title: 'Loading'
      }
    },
    {
      path: '/astaxin',
      name: 'AstaxinAnti',
      component: Astaxin,
      meta: {
        title: 'Verifieringsfråga'
      }
    },
    {
      path: '/astaxin/cn',
      name: 'AstaxinCN',
      component: AstaxinCN,
      meta: {
        title: '会员中心'
      }
    },
    {
      path: '/astaxin/scan',
      name: 'AstaxinScan',
      component: AstaxinScan,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/muteng/result',
      name: 'MuTengResult',
      component: MuTengResult,
      meta: {
        title: '查询结果'
      }
    },
    {
      path: '/muteng/claimResult',
      name: 'MuTengClaimResult',
      component: MuTengClaimResult,
      meta: {
        title: '积分结果'
      }
    },
    {
      path: '/muteng/rule',
      name: 'MuTengRule',
      component: MuTengRule,
      meta: {
        title: '规则说明'
      }
    },
    {
      path: '/aobang/result',
      name: 'AobangResult',
      component: AobangResult,
      meta: {
        title: '中生奥邦积分商城'
      }
    },
    {
      path: '/mogujia/scan',
      name: 'MoGuJiaScan',
      component: MoGuJiaScan,
      meta: {
        title: 'iDoeeoD'
      }
    },
    {
      path: '/mogujia/result',
      name: 'MoGuJiaResult',
      component: MoGuJiaResult,
      meta: {
        title: 'iDoeeoD'
      }
    },
    {
      path: '/mogujia/follow',
      name: 'MoGuJiaFollow',
      component: MoGuJiaFollow,
      meta: {
        title: 'iDoeeoD'
      }
    },
    {
      path: '/fty/scan',
      name: 'FengTuoYuanScan',
      component: FengTuoYuanScan,
      meta: {
        title: '丰驼源'
      }
    },
    {
      path: '/fty/result',
      name: 'FengTuoYuanResult',
      component: FengTuoYuanResult,
      meta: {
        title: '丰驼源'
      }
    },
    {
      path: '/fty/trace',
      name: 'FengTuoYuanTrace',
      component: FengTuoYuanTrace,
      meta: {
        title: '丰驼源'
      }
    },
    {
      path: '/fty/activity',
      name: 'FengTuoYuanActivity',
      component: FengTuoYuanActivity,
      meta: {
        title: '丰驼源'
      }
    },
    {
      path: '/ankang/scan',
      name: 'AnKangScan',
      component: AnKangScan,
      meta: {
        title: '秦岭.高山凰散养原生土鸡'
      }
    },
    {
      path: '/ankang',
      name: 'AnKangIndex',
      component: AnKangIndex,
      meta: {
        title: '秦岭.高山凰散养原生土鸡'
      }
    },
    {
      path: '/ankang/trace',
      name: 'AnKangTrace',
      component: AnKangTrace,
      meta: {
        title: '秦岭.高山凰散养原生土鸡'
      }
    },
    {
      path: '/',
      name: 'ErrorPage',
      component: ErrorPage,
      meta: {
        title: '错误页'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js